// @flow

import { hpfetch } from '../util';
import type {
  djangoModelApiResponse,
  wrappedApiResponseType,
} from '../apiTypes';
import type { categoryType } from '../../types';

export const getSingle = (
  id: number,
): Promise<wrappedApiResponseType<categoryType>> =>
  hpfetch(`categories/${id}/`);

// This remapping is done so that we can conveniently use the higher-order redux reducer and sagas
export const getMany = (): djangoModelApiResponse<categoryType> =>
  hpfetch('categories/').then(res => ({
    ...res,
    body: {
      count: res.body.length,
      next: null,
      previous: null,
      results: res.body,
    },
  }));

export const getPreferences = (): djangoModelApiResponse<categoryType> =>
  hpfetch('categories/profile_preferences/').then(res => ({
    ...res,
    body: {
      count: res.body.length,
      next: null,
      previous: null,
      results: res.body,
    },
  }));
